
import React from "react";
import FAQItem from "./FAQItem";

const TargetGenerationSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Target Generation</h2>
      
      <FAQItem question="How are location targets generated?">
        <p className="text-foreground mb-3">
          Location targets are generated using a sophisticated algorithm that:
        </p>
        <ul className="list-disc list-inside text-foreground space-y-1 ml-4">
          <li>Randomly selects coordinates from a database of verified global locations</li>
          <li>Ensures all targets have Google Street View coverage</li>
          <li>Covers diverse geographical regions and environments</li>
          <li>Provides no advance information about target characteristics</li>
          <li>Maintains complete randomness to prevent bias</li>
        </ul>
      </FAQItem>

      <FAQItem question="What types of locations might I encounter?">
        <p className="text-foreground mb-3">
          Our database includes verified locations from over 100 cities worldwide, spanning:
        </p>
        <ul className="list-disc list-inside text-foreground space-y-1 ml-4">
          <li>Urban environments (streets, buildings, landmarks)</li>
          <li>Natural settings (parks, waterfronts, landscapes)</li>
          <li>Cultural sites and public spaces</li>
          <li>Diverse architectural styles and time periods</li>
          <li>Various climate zones and geographical features</li>
        </ul>
      </FAQItem>

      <FAQItem question="Are image targets also randomly generated?">
        <p className="text-foreground">
          Yes, image targets are randomly selected from a curated database of high-quality photographs covering diverse subjects, ensuring each session presents genuinely unknown content.
        </p>
      </FAQItem>
    </section>
  );
};

export default TargetGenerationSection;
